import { WIRING_STEPS, validateConnection } from '../circuit/WiringValidator';

export class ConnectionTool {
  private index = 0;
  private first: string | null = null;
  active = false;

  constructor(
    private onStep: (index: number, text: string, endpoints: string[]) => void,
    private onMessage: (message: string, kind: 'success'|'error') => void,
    private onComplete: () => void
  ) {}

  start(): void {
    this.active = true;
    this.index = 0;
    this.first = null;
    this.emit();
  }

  stop(): void {
    this.active = false;
    this.first = null;
  }

  select(id: string): void {
    if (!this.active) return;
    const step = WIRING_STEPS[this.index];
    if (!this.first) {
      if (id !== step.from && id !== step.to) {
        this.onMessage(`此步骤不应从“${id}”开始，请观察提示。`, 'error');
        return;
      }
      this.first = id;
      this.onMessage(`已选择 ${id}，请选择另一端。`, 'success');
      return;
    }
    if (!validateConnection(step, this.first, id)) {
      this.onMessage(`连接错误：${this.first} 不能在此步骤接 ${id}。`, 'error');
      this.first = null;
      return;
    }
    this.onMessage(`连接正确：${step.text}`, 'success');
    this.index++;
    this.first = null;
    if (this.index >= WIRING_STEPS.length) {
      this.active = false;
      this.onComplete();
    } else this.emit();
  }

  private emit(): void {
    const step = WIRING_STEPS[this.index];
    this.onStep(this.index, step.text, [step.from, step.to, '错误端点']);
  }
}
